/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="store_login_unit_manage_menu">店舗管理者画面</div>
        <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
            <p class="checkSetting_text">TOPボタンA メニュー画面</p>
            <table style="margin: auto">
                <tbody >
                    <tr v-for="dailyCheckButtonData in dailyCheckButtonSettings1" :key="dailyCheckButtonData.dailyCheckButtonNo">
                        <td v-if="dailyCheckButtonData.dailyCheckButtonNo == 1" class="wd200 menu_center">ボタンA-①</td>
                        <td v-else-if="dailyCheckButtonData.dailyCheckButtonNo == 2" class="wd200 menu_center">ボタンA-②</td>
                        <td v-else-if="dailyCheckButtonData.dailyCheckButtonNo == 3" class="wd200 menu_center">ボタンA-③</td>
                        <td v-else-if="dailyCheckButtonData.dailyCheckButtonNo == 4" class="wd200 menu_center">ボタンA-④</td>
                        <td v-else-if="dailyCheckButtonData.dailyCheckButtonNo == 5" class="wd200 menu_center">ボタンA-⑤</td>
                        <td v-else-if="dailyCheckButtonData.dailyCheckButtonNo == 6" class="wd200 menu_center">ボタンA-⑥</td>
                        <td v-else-if="dailyCheckButtonData.dailyCheckButtonNo == 99" class="wd200 menu_center">ボタンA-⑦</td>
                        <td class="wd400">{{dailyCheckButtonData.dailyCheckButtonName}}</td>
                        <td v-if="dailyCheckButtonData.displayFlg" class="wd200 menu_center">表示</td>
                        <td v-else-if="!dailyCheckButtonData.displayFlg" class="wd200 menu_center">非表示</td>
                        <td class="checkSetting_buttan_unit checkSetting_box ">
                            <ul><li>
                                <router-link 
                                    @click.native="setPageInfo(dailyCheckButtonData.dailyCheckButtonId, 'day1', dailyCheckButton1MenuId,dailyCheckButtonData.dailyCheckButtonNo, dayButtonName[dailyCheckButtonData.dailyCheckButtonNo-1], dailyCheckButtonData.dailyCheckButtonNo)"
                                    :to="{ name: 'manageCheckImplementationViewSetting', params: { bottunid:dailyCheckButtonData.dailyCheckButtonNo }}">
                                    編集</router-link>
                            </li></ul>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p class="checkSetting_text">TOPボタンD メニュー画面</p>
            <table style="margin: auto">
                <tbody >
                <tr v-for="dailyCheckButton2Data in dailyCheckButtonSettings2" :key="dailyCheckButton2Data.dailyCheckButtonNo">
                    <td v-if="dailyCheckButton2Data.dailyCheckButtonNo == 1" class="wd200 menu_center">ボタンD-①</td>
                    <td v-else-if="dailyCheckButton2Data.dailyCheckButtonNo == 2" class="wd200 menu_center">ボタンD-②</td>
                    <td v-else-if="dailyCheckButton2Data.dailyCheckButtonNo == 3" class="wd200 menu_center">ボタンD-③</td>
                    <td v-else-if="dailyCheckButton2Data.dailyCheckButtonNo == 4" class="wd200 menu_center">ボタンD-④</td>
                    <td v-else-if="dailyCheckButton2Data.dailyCheckButtonNo == 5" class="wd200 menu_center">ボタンD-⑤</td>
                    <td v-else-if="dailyCheckButton2Data.dailyCheckButtonNo == 6" class="wd200 menu_center">ボタンD-⑥</td>
                    <td v-else-if="dailyCheckButton2Data.dailyCheckButtonNo == 99" class="wd200 menu_center">ボタンD-⑦</td>
                    <td class="wd400">{{dailyCheckButton2Data.dailyCheckButtonName}}</td>
                    <td v-if="dailyCheckButton2Data.displayFlg" class="wd200 menu_center">表示</td>
                    <td v-else-if="!dailyCheckButton2Data.displayFlg" class="wd200 menu_center">非表示</td>
                    <td class="checkSetting_buttan_unit checkSetting_box ">
                        <ul><li>
                            <router-link 
                                @click.native="setPageInfo(dailyCheckButton2Data.dailyCheckButtonId, 'day2', dailyCheckButton2MenuId,dailyCheckButton2Data.dailyCheckButtonNo, day2ButtonName[dailyCheckButton2Data.dailyCheckButtonNo-1], dailyCheckButton2Data.dailyCheckButtonNo)"
                                :to="{ name: 'manageCheckImplementationViewSetting', params: { bottunid:dailyCheckButton2Data.dailyCheckButtonNo }}">
                                編集</router-link>
                        </li></ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CheckImplementationSettingList',
    data: function () {
        return {
            brandId: '',
            dayButtonName:[
                "ボタンA-①","ボタンA-②","ボタンA-③","ボタンA-④","ボタンA-⑤","ボタンA-⑥","ボタンA-⑦"
            ],
            day2ButtonName:[
                "ボタンD-①","ボタンD-②","ボタンD-③","ボタンD-④","ボタンD-⑤","ボタンD-⑥","ボタンD-⑦"
            ],
            dailyCheckButtonSettings1: [],
            dailyCheckButtonSettings2: [],
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        dailyCheckButton1MenuId() {
            var button = this.topButtonSettings.filter(topButtonSetting => {return topButtonSetting.topButtonNo === 1})[0]
            return button.topButtonId;
        },
        dailyCheckButton2MenuId() {
            var button = this.topButtonSettings.filter(topButtonSetting => {return topButtonSetting.topButtonNo === 4})[0]
            return button.topButtonId;
        }
    },
    created: function(){
        this.calc();
        this.clearPageInfo();
    },
    methods:{
        async calc(){
            // 企業IDを取得
            this.brandId = this.$store.getters['brand/id'];

            //権限情報を取得
            this.auth = this.$store.getters['manager/manager'].authorityKbn;

            var currentTime = this.getCurrentTime();
            // メニュー設定一覧取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/', { params: { datetime: currentTime}})
                .then(response => (this.topButtonSettings = response.data.topButtonSettings ,
                    this.dailyCheckButtonSettings1 = response.data.dailyCheckButtonSettings1,
                    this.dailyCheckButtonSettings2 = response.data.dailyCheckButtonSettings2,
                    this.cookingCheckButtonSettings = response.data.cookingCheckButtonSettings))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                });

        },
        getCurrentTime() {
            // 当日日付をyyyymmddhhmmssで返却
            var now = new Date();
            var res = now.getFullYear() +
                      this.padZero(now.getMonth() + 1) +
                      this.padZero(now.getDate()) +
                      this.padZero(now.getHours()) +
                      this.padZero(now.getMinutes()) +
                      this.padZero(now.getSeconds());
            return res;
        },
        padZero(num) {
            //先頭ゼロ付加
            var result;
            if (num < 10) {
                result = "0" + num;
            } else {
                result = "" + num;
            }
            return result;
        },
        setPageInfo(id,viewType,menuId,buttonId,buttonName,buttonNo=0) {
            var pageInfo = {
                id: id,
                viewType: viewType,
                menuId: menuId,
                buttonId: buttonId,
                buttonName: buttonName,
                buttonNo: buttonNo
            }
            this.$store.dispatch('checkPage/setPageInfo', pageInfo);
        },
        clearPageInfo() {
            this.$store.dispatch('checkPage/clearPageInfo')
        }
    }
}
</script>
<style scoped>
td {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>